import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { ClientsProvider } from './context/ClientsContext';
import { DocumentsProvider } from './context/DocumentsContext';
import { NotificationsProvider } from './context/NotificationsContext';
import Layout from './components/Layout/Layout';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import CreateDocument from './pages/CreateDocument';
import DocumentHistory from './pages/DocumentHistory';
import DocumentPreview from './pages/DocumentPreview';
import AccountSettings from './pages/AccountSettings';
import NotFound from './pages/NotFound';
import Login from './pages/Login';
import LegalNotice from './pages/LegalNotice';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import TermsOfUse from './pages/TermsOfUse';
import RefundPolicy from './pages/RefundPolicy';
import HelpCenter from './pages/HelpCenter';
import Contact from './pages/Contact';
import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ThemeProvider>
          <NotificationsProvider>
            <ClientsProvider>
              <DocumentsProvider>
                <Routes>
                  <Route path="/" element={<Landing />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/legal" element={<LegalNotice />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<TermsOfService />} />
                  <Route path="/terms-of-use" element={<TermsOfUse />} />
                  <Route path="/refund" element={<RefundPolicy />} />
                  <Route path="/help" element={<HelpCenter />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/app" element={<Layout />}>
                    <Route index element={<Dashboard />} />
                    <Route path="clients" element={<Clients />} />
                    <Route path="clients/:id" element={<ClientDetail />} />
                    <Route path="create" element={<CreateDocument />} />
                    <Route path="documents" element={<DocumentHistory />} />
                    <Route path="documents/:id" element={<DocumentPreview />} />
                    <Route path="account" element={<AccountSettings />} />
                    <Route path="*" element={<Navigate to="/app" replace />} />
                  </Route>
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </DocumentsProvider>
            </ClientsProvider>
          </NotificationsProvider>
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;